export default __webpack_public_path__ + "static/media/17.9aa6a378.jpg";